import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import { logoImg, MainItem } from './mainItem';

const MainVisual = () => {
  const slideRef = useRef(null);
  const progressRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [slidePlay, setSlidePlay] = useState(true);
  const [progressWidth, setProgressWidth] = useState(0);
  let interval = undefined;

  const settings = {
    infinite: true,
    speed: 500,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    ref: slideRef,
    arrows: false,
    pauseOnHover: false,
    fade: true,
    cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
    beforeChange(currentSlide, nextSlide) {
      setCurrentSlide(nextSlide + 1);
    },
  };

  useEffect(() => {
    setCurrentSlide(0);
  }, []);

  const onNext = useCallback(() => {
    slideRef.current.slickNext();
    setProgressWidth(0);
  }, []);

  const onPrev = useCallback(() => {
    slideRef.current.slickPrev();
    setProgressWidth(0);
  }, []);

  const onToggle = useCallback(() => {
    if (slidePlay) {
      slideRef.current.slickPause();
      setSlidePlay(false);
    } else {
      slideRef.current.slickPlay();
      setSlidePlay(true);
    }
  }, [slidePlay]);

  useEffect(() => {
    if (currentSlide === 0) {
      setCurrentSlide(1);
    }
    slideRef.current.slickPause();
    if (slidePlay) {
      interval = setInterval(() => {
        setProgressWidth((prev) => prev + 1);
        if (progressWidth === 100) {
          setProgressWidth(0);
          slideRef.current.slickNext();
        }
      }, 50);
    } else {
      clearInterval(interval);
    }
    progressRef.current.style.width = progressWidth + '%';
    return () => clearInterval(interval);
  }, [slidePlay, progressWidth]);

  return (
    <>
      <section className="mainVisual">
        <Slider {...settings} ref={slideRef}>
          {MainItem.map((it, idx) => (
            <>
              <figure
                className={'itm itm0' + it.id + (idx + 1 === currentSlide ? ' on' : '')}
                key={it.id}
              >
                <div className={idx + 1 === currentSlide ? 'container on' : 'container'}>
                  <p>{it.intro}</p>
                  <h2 className={`mainTit0${idx + 1}`}>{it.main}</h2>
                  <p className="smallP">{it.detail}</p>
                  <Link to={it.link}>
                    <span>{it.button}</span>
                  </Link>
                </div>
              </figure>
            </>
          ))}
        </Slider>
        <div className="container">
          <div className="flex">
            <div className="sliderNum">
              {currentSlide}&nbsp; /&nbsp;{MainItem.length}
            </div>
            <div className="progressBar">
              <div ref={progressRef}></div>
            </div>
            <div className="slideBtn">
              <button className="arrow_left" onClick={onPrev}></button>
              <button type="button" onClick={onToggle} className="arrow_pause">
                {slidePlay ? (
                  <img src="/images/icon/slide_stop.png" alt="슬라이드 자동재생 중지" />
                ) : (
                  <img src="/images/icon/slide_play.png" alt="슬라이드 자동재생 시작" />
                )}
              </button>

              <button className="arrow_right" onClick={onNext}></button>
            </div>
          </div>
        </div>
        <div className="inner">
          <div className="scroll flex">
            scroll
            <div>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </section>
      <section className="mainSolution">
        <div className="container">
          <p>product</p>
          <h2>
            WithUS Security의 <br className="w590" /> 보안 솔루션
          </h2>
          <ul className="flex">
            <li>
              <Link to="/product/EG-Platform">
                <h3>EG-Platform</h3>
                <p>
                  이메일의 수신부터 발신까지 전구간을
                  <br className="w387" /> 체계적으로 보호하고, 발생 이슈를 모두 해결해주는
                  <br className="w1200" />
                  All-In-One 이메일 통합 보안 플랫폼
                </p>
              </Link>
            </li>
            <li>
              <Link to="/product/SentinelONE">
                <h3>SentinelOne</h3>
                <p>
                  위협 라이프사이클의 모든 단계에서
                  <br className="w387" /> 각종 공격으로부터 모든 엔드포인트를 방어하는
                  <br className="w1200" />
                  자율형 AI 엔드포인트 보안 소프트웨어
                </p>
              </Link>
            </li>
            <li>
              <Link to="/product/BaroPAM">
                <h3>BaroPAM</h3>
                <p>
                  기존 ID/ PW를 이용한 Login 방식에
                  <br className="w387" /> 동적 키(OTP)를 추가해 해커로부터 정보자산을
                  <br className="w1248" />
                  보호하는 강력한 접근제어 2차 인증 솔루션
                </p>
              </Link>
            </li>
          </ul>
        </div>
      </section>
      <section className="client">
        <div className="container">
          <h2>주요 고객사</h2>
          <p>
            위더스 시큐리티는 최첨단 기술과 전문인력으로
            <br className="w590" /> 최상의 결과물을 제공합니다.
          </p>
          <div className="clientGrid">
            {logoImg.map((it) => (
              <div key={it.id} className="item">
                <figure>
                  <img src={it.src} alt="" />
                </figure>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="inquiry">
        <div className="relative container">
          <div className="content">
            <p>WithUS Security</p>
            <h2>
              고객의 Needs를 분석하여
              <br className="w357" /> 고객 만족도를 최우선으로 <br className="w770" />
              생각하는 기업
            </h2>
            <ul className="flex">
              <li>
                <Link to="/contact-us/product/contact-us">제품문의</Link>
              </li>
              <li>
                <Link to="/contact-us/partner/contact-us">제휴문의</Link>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </>
  );
};

export default MainVisual;
